module.exports = __webpack_public_path__ + "img/logo_wit.6ada4bfb.png";